export default __webpack_public_path__ + "static/media/D2.18705984.18705984.png";